import { KeyValueObj } from "@/common/types";
import { ViewWallet } from "./style";
import { IwalletStatus } from ".";
import { Button } from "@/common/components/button";
import { useState } from "react";
import Form from "@/common/components/form/Form";
import CompanyDetails from "./sub/companyDetails";

const ViewMore = ({ data }: { data: KeyValueObj }) => {
  const [isAcknowledged, setIsacknowledged] = useState<boolean>(false);
  const handleAcknowledge = () => {
    setIsacknowledged(true);
  };
  return (
    <ViewWallet>
      <h1>Company Data</h1>
      <div className="details">
        <CompanyDetails
          title="Company Name"
          value={data?.company_name?.value}
        />
        <CompanyDetails
          title="Company Type"
          value={data?.company_type?.value}
        />
        <CompanyDetails title="Email" value="mmgalapagous09@gmail.com" />
        <CompanyDetails title="RC Number" value="222222" />
        <CompanyDetails title="TIN" value="22222222133121" />
        <CompanyDetails title="Phone Number" value="08123280394" />
        <CompanyDetails title="Company Address" value="Garki Abuja" />
      </div>
      {data?.status?.value?.props?.children?.toLowerCase() ===
      IwalletStatus.PENDING ? (
        <div className="preview-control">
          {isAcknowledged && (
            <div className="ack">
              <Form
                removeSubmitButton
                processInputs={() => alert("hello")}
                formInputs={[
                  {
                    name: "account_number",
                    prompt: "Wallet Account Number",
                    required: true,
                  },
                  {
                    name: "revenue_head",
                    prompt: "Revenue Head ID",
                    required: true,
                  },
                  {
                    name: "pin",
                    prompt: "PIN",
                    required: true,
                    inputType: "password",
                  },
                  {
                    name: "password",
                    prompt: "Password",
                    required: true,
                    inputType: "password",
                  },
                ]}
              />
            </div>
          )}
          <Button onClick={handleAcknowledge} primary>
            {isAcknowledged ? "Complete" : "Acknowledge"}
          </Button>
        </div>
      ) : null}
    </ViewWallet>
  );
};

export default ViewMore;
